import {
  CalendarIcon,
  CheckmarkGreenIcon,
  ClockIcon,
  PauseIcon,
  WarningYellowIcon
} from 'assets/icons';
import { TaskStatus } from 'constants/enums';

export enum TaskType {
  CLINICAL = 0
}

export enum OverdueUnit {
  MINUTE = 'minutes',
  HOUR = 'hours',
  DAY = 'days',
  WEEK = 'weeks',
  MONTH = 'months'
}

export const hasInvalidSelection = (tasks: ITask[]) => {
  return tasks.some((task) => !isStatusActionable(task));
};

export const isStatusActionable = (task: ITask) => {
  return [
    parseInt(TaskStatus.DUE),
    parseInt(TaskStatus.OVERDUE),
    parseInt(TaskStatus.ACTIVE)
  ].includes(task.status);
};

export const getIconColorFromStatus = (status: string) => {
  switch (status) {
    case TaskStatus.ACTIVE:
    case TaskStatus.DUE:
      return 'text-blue-light';
    case TaskStatus.ON_HOLD:
      return 'text-categoryYellow';
    default:
      return '';
  }
};

export const getIconFromStatus = (status: string) => {
  switch (status) {
    case TaskStatus.ACTIVE:
      return CalendarIcon;
    case TaskStatus.DUE:
      return ClockIcon;
    case TaskStatus.OVERDUE:
      return WarningYellowIcon;
    case TaskStatus.COMPLETED:
      return CheckmarkGreenIcon;
    default:
      return PauseIcon;
  }
};
